import { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { ColorPicker } from "primereact/colorpicker";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Loading from "../components/Loading";
import Menu from "../components/Menu";

import api from "../services/api";

export default function Turmas() {
    const [cor, setCor] = useState('');
    const [hex, setHex] = useState('#FFFFFF');
    const [metaProducaoDiaria, setMetaProducaoDiaria] = useState('');
    const [nome, setNome] = useState('');
    const [turmas, setTurmas] = useState([]);

    const [display, setDisplay] = useState(false);
    const [editing, setEditing] = useState(false);
    const [index, setIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState(null)

    const toast = useRef(null);

    const handleSubmit = () => {
        if (nome === '' || cor === '' || metaProducaoDiaria === '' || !Number.isInteger(Number(metaProducaoDiaria))) {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Por favor, preencha todos os campos antes de prosseguir'
            });
            return;
        }
        api.post('cadastros/turmas/store', {
            "cor": cor,
            "hex": `#${hex}`,
            "meta_producao_diaria": Number(metaProducaoDiaria),
            "nome": nome
        }).then((response) => {
            let copy = [...turmas];
            copy.push(response.data.turma);
            setTurmas(copy);

            hideDialog();

            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    const handleUpdate = () => {
        if (nome === '' || cor === '' || metaProducaoDiaria === '' || !Number.isInteger(Number(metaProducaoDiaria))) {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Por favor, preencha todos os campos antes de prosseguir'
            });
            return;
        }
        api.post('cadastros/turmas/update', {
            "turma_id": selected,
            "cor": cor,
            "hex": `#${hex}`,
            "meta_producao_diaria": Number(metaProducaoDiaria),
            "nome": nome
        }).then((response) => {
            let copy = [...turmas];
            copy[index] = response.data.turma;
            setTurmas(copy);

            hideDialog();

            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    const handleUpdateMetasProducao = (event) => {
        event?.preventDefault();

        const metasInvalidas = turmas.some(turma => (
            turma.meta_producao_diaria === '' ||
            !Number.isInteger(Number(turma.meta_producao_diaria))
        ));

        if (metasInvalidas) {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Informe uma meta de produção diária inteira para todas as turmas'
            });
            return;
        }

        Promise.all(turmas.map(turma => api.post('cadastros/turmas/update', {
            "turma_id": turma.id,
            "meta_producao_diaria": Number(turma.meta_producao_diaria)
        }))).then((responses) => {
            setTurmas(responses.map(response => response.data.turma));

            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: 'Metas de produção atualizadas com sucesso'
            });
        }).catch((error) => {
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    const handleMetaProducaoChange = (turmaId, value) => {
        setTurmas(turmas.map(turma => (
            turma.id === turmaId
                ? { ...turma, meta_producao_diaria: value }
                : turma
        )));
    }

    const showDialog = (rowData, editing) => {
        if(editing) {
            setNome(rowData.nome);
            setCor(rowData.cor);
            setHex(rowData.hex);
            setMetaProducaoDiaria(rowData.meta_producao_diaria);
        }
        setDisplay(true);
    }

    const hideDialog = () => {
        setDisplay(false);
        setEditing(false);
        setIndex(null);
        setSelected(null);
        setCor('');
        setMetaProducaoDiaria('');
        setNome('');
    }

    useEffect(() => {
        setLoading(true);
        api.get('cadastros/turmas').then((response) => {
            setTurmas(response.data);

            setLoading(false);
        }).catch((error) => {
            toast.current.show({
                summary: 'Erro no Servidor',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });
    }, []);

    if(loading) {
        return (
            <Loading />
        )
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Dialog footer={() => (
                <div>
                    <Button className="p-button-secondary" label="Cancelar" onClick={hideDialog} />
                    <Button className="p-button-success" label={editing ? "Salvar" : "Cadastrar"} onClick={editing ? handleUpdate : handleSubmit} />
                </div>
            )} header={editing ? "Editar" : "Cadastrar"} onHide={hideDialog} visible={display} style={{ width: '30vw' }}>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nome">Nome: </label>
                        <InputText
                            onChange={e => {
                                if ((/['A-z']/.test(e.target.value) && (e.target.value.length < 2)) || e.target.value === '') {
                                    setNome(e.target.value)
                                }
                            }}
                            placeholder="A, B..."
                            value={nome}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="meta_producao_diaria">Meta de Produção Diária: </label>
                        <InputText
                            id="meta_producao_diaria"
                            onChange={e => setMetaProducaoDiaria(e.target.value)}
                            step="1"
                            type="number"
                            value={metaProducaoDiaria}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="cor">Cor: </label><br></br>
                        <InputText
                            onChange={e => setCor(e.target.value)}
                            placeholder="Vermelho"
                            value={cor}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="hex">Cor do Gráfico</label><br></br>
                        <ColorPicker
                            format="hex"
                            onChange={e => setHex(e.value)}
                            style={{ width: '100%' }}
                            value={hex}
                        />
                    </div>
                </div>
            </Dialog>

            <form onSubmit={handleUpdateMetasProducao}>
                <Card header={() => (
                    <div className="p-d-flex p-flex-row p-jc-between p-ai-start">
                        <h1 className="p-m-2">Turmas</h1>
                        <div>
                            <Button className="p-button-success p-m-2" label="Salvar metas" type="submit" />
                            <Button className="p-button-primary p-m-2" icon="pi pi-plus" onClick={showDialog} type="button" />
                        </div>
                    </div>
                )} className="p-m-3">
                    <DataTable value={turmas} >
                        <Column header="ID" field="id" />
                        <Column header="Nome" field="nome" />
                        <Column header="Meta de Produção Diária" body={(rowData) => (
                            <InputText
                                onChange={e => handleMetaProducaoChange(rowData.id, e.target.value)}
                                step="1"
                                type="number"
                                value={rowData.meta_producao_diaria}
                            />
                        )} />
                        <Column header="Cor" field="cor" />
                        <Column header="Cor do Gráfico" body={(rowData) => (
                            <div style={{ width: '25px', height: '25px', backgroundColor: rowData.hex }} />
                        )} />
                        <Column header="Ações" body={(rowData, index) => (
                            <div>
                                <Button 
                                    className="p-button-primary" 
                                    icon="pi pi-pencil" 
                                    onClick={() => {
                                        setEditing(true);
                                        setSelected(rowData.id);
                                        showDialog(rowData, true);
                                        setIndex(index.rowIndex)
                                    }}
                                    type="button" />
                            </div>
                        )} />
                    </DataTable>
                </Card>
            </form>
        </div>
    )
}
